import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Carousel, Empty } from 'antd'

import { ChevronLeftIcon, ChevronRightIcon } from '@/components/Icons'
import BREAKPOINTS from '@/libs/constants/breakpoints'
import { isValidArray } from '@/libs/utils/array'

interface ProductCarouselProps {
  className?: string
  style?: React.CSSProperties
  dataSrc: {
    title: string
    urls: {
      type: string
      url: string
    }[]
  }[]
}

function ProductCarousel({ style, dataSrc }: ProductCarouselProps) {
  const { t } = useTranslation()
  const deviceW = window.innerWidth

  const imageBaseOnScreenWidth = useCallback(
    (arrayData) => {
      let type = 'small'

      if (deviceW >= BREAKPOINTS.xl) {
        type = 'full'
      } else if (deviceW >= BREAKPOINTS.lg) {
        type = 'large'
      } else if (deviceW >= BREAKPOINTS.md) {
        type = 'medium'
      }

      const selectedImage = arrayData.find((item) => item.type === type)

      return selectedImage.url
    },
    [deviceW],
  )

  const renderSliderContent = (array) => {
    return array.map((item) => (
      <div
        key={item.title}
        className="product-details__carousel__container__item"
      >
        <img
          alt={`${item.title}-${item.type}`}
          src={imageBaseOnScreenWidth(item.urls)}
        />
      </div>
    ))
  }

  return (
    <div className="product-details__carousel" style={style}>
      <Carousel
        arrows
        fade
        infinite
        className="product-details__carousel__container"
        dots={{ className: 'product-details__carousel__list' }}
        nextArrow={<ChevronRightIcon />}
        prevArrow={<ChevronLeftIcon />}
        speed={1000}
      >
        {isValidArray(dataSrc)
          ? (
            renderSliderContent(dataSrc)
          )
          : <Empty description={t('noData')} />}
      </Carousel>
    </div>
  )
}

export default ProductCarousel
